<template>
	<div class="col">
		<div>
			<b-btn  variant="primary" v-if="userPreferenceStore.coi.lightMode" @click="isCOIHistoryOpen = !isCOIHistoryOpen">{{customerOrder.shippingInfo ? 'Toggle History +': 'Toggle History'}}</b-btn>
			<b-collapse v-if="userPreferenceStore.coi.lightMode && !isCOIHistoryOpen">
				<b-card no-body>
					<!-- TODO making tab elements different colors is hard/not possible for some reason. Ask if this is necessary. Might have to do it with a button group afterall.-->
					<b-tabs
						pills card vertical
						lazy
						size="sm"
						nav-class="p-0"
						v-bind:class="{ 'contains-multiorder-history': multiorderItems.length > 0 }"
					><!-- tabs -->
						<b-tab
							title="Kommentare"

						><!-- tab -->
							<div id="tab-history-table">
								<b-table
									id="table-log-manual"
									style="font-family:'Lucida Console', monospace"
									striped hover small
									:items="itemHistory.manual"
									:fields="fields.autoAndManual"
								></b-table>
								<!-- button
									v-if="'idle' === textInput.comment.state"
									class="btn btn-outline-secondary btn-block btn-sm"
									id="add_notiz_button"
									type="button"
									@click="commentAdd()"
								>
									Notiz <b>hinzufügen</b> ✚
								</button -->
								<b-overlay
									v-if="['edit','idle'].includes(textInput.comment.state)"
									id="overlay-background"
									:show="textInput.comment.savingInProgress"
									variant="transparent"
									opacity="0.80"
									blur="2px"
									rounded="sm"
								>
									<textarea
										v-model="textInput.comment.value"
										style="min-width: 100%;"
										rows="3"
										minlength="1"
									></textarea>
									<b-button
										v-if="textInput.comment.value"
										class="btn btn-primary float-right mb-2"
										type="button"
										size="sm"
										@click="commentSave()"
										:disabled="textInput.comment.savingInProgress || (!textInput.comment.value)"
									><b>hinzufügen</b></b-button>
									<b-button
										v-if="textInput.comment.value"
										class="btn btn-danger float-right mb-2 mr-1"
										type="button"
										size="sm"
										@click="commentAddAbort()"
										:disabled="textInput.comment.savingInProgress"
									><b>abbrechen</b></b-button>
								</b-overlay>
							</div>
						</b-tab>
						<b-tab :title-item-class="(customerOrder.shippingInfo) ? 'bg-danger rounded' :null" 
						title="Versand-Info" 
						><!-- to change the text color - needs additional when tab not activ than text color white - dont know how atm
							:title-link-class="(customerOrder.shippingInfo) ? 'text-light' : 'text-primary'"-->
						<!-- tab -->
							<span v-if="!textInput.shippingInfo.currentlyEditing" >{{customerOrder.shippingInfo}}</span>
							<b-button
								v-if="!textInput.shippingInfo.currentlyEditing"
								@click="() => textInput.shippingInfo.currentlyEditing = true"
								size="sm"
								variant="primary"
							><!-- button -->
								<span v-if="customerOrder.shippingInfo">✎</span>
								<span v-else>Versand-Info hinzufügen</span>
							</b-button>
							<textarea
								v-else
								v-model="textInput.shippingInfo.value"
								style="min-width: 100%;"
								rows="3"
								minlength="1"
							></textarea>
							<b-button
								v-if="textInput.shippingInfo.currentlyEditing && textInput.shippingInfo.value != customerOrder.shippingInfo"
								class="btn btn-primary float-right mb-2"
								type="button"
								size="sm"
								@click="saveShippingInfo()"
								:disabled="textInput.shippingInfo.savingInProgress || (textInput.shippingInfo.value == customerOrder.shippingInfo)"
							><!-- button -->
								<b v-if="customerOrder.shippingInfo">speichern</b>
								<b v-else>hinzufügen</b>
							</b-button>
							<b-button
								v-if="textInput.shippingInfo.currentlyEditing"
								class="btn btn-danger float-right mb-2 mr-1"
								type="button"
								size="sm"
								@click="() => { textInput.shippingInfo.value = customerOrder.shippingInfo; textInput.shippingInfo.currentlyEditing = false }"
								:disabled="textInput.shippingInfo.savingInProgress"
							>
								<b>Abbrechen</b>
							</b-button>
						</b-tab>
						<b-tab
							title="Verlauf"
							:disabled="textInput.comment.savingInProgress"
						><!-- tab -->
							<b-table
								id="table-log-auto"
								class="monospace"
								striped hover small
								:items="itemHistory.auto"
								:fields="fields.autoAndManual"
							></b-table>
						</b-tab>
						<b-tab
							v-if="multiorderItems.length > 0"
							title="Multiorder"
							:disabled="textInput.comment.savingInProgress"
						><!-- tab -->
							<b-overlay
								v-if="multiorderItems"
								id="overlay-background"
								:show="!multiorderItems"
								variant="transparent"
								opacity="0.80"
								blur="2px"
								rounded="sm"
							>
								<b-table
									id="table-multiorder-history"
									style="font-family:'Lucida Console', monospace"
									striped hover small
									:items="multiorderItems"
									:fields="fields.multiorder"
								><!-- table -->
									<template #cell(anything)="data">
										<div v-if="data.value.type === 'orderState'">
											<span v-if="data.value.value == 'Erstattet'"><span class="blinker">🔴</span>Erstattet</span>
											<span v-else >{{data.value.value}}</span>
										</div>
										<div v-else-if="data.value.type === 'date'">
											<span v-if="data.value.value.badgeLabel == 'Multiorder versendet'">
												<b-badge class="badge-orange">{{data.value.value.badgeLabel}}:{{data.value.value.date}}</b-badge>
											</span>
											<div v-else>
												<span>{{data.value.value.badgeLabel}}:</span>
												<b-badge class="badge-orange">{{data.value.value.date}}</b-badge>
											</div>
										</div>
									</template>
									<template #cell(search)="data">
										<a @click="openCustomerOrderSearch(data.value)" style="cursor:pointer; color:#3baced; text-decoration:underline;">Öffnen</a>
									</template>
									<template #cell(virtualQuantity)="data">
										{{ (data.value > 0) ? data.value : "-" }}
									</template>
								</b-table>
							</b-overlay>
						</b-tab>
					</b-tabs>
				</b-card>
			</b-collapse>
			<b-card no-body v-else>
				<!-- TODO making tab elements different colors is hard/not possible for some reason. Ask if this is necessary. Might have to do it with a button group afterall.-->
				<b-tabs
					pills card vertical
					lazy
					size="sm"
					nav-class="p-0"
					v-bind:class="{ 'contains-multiorder-history': multiorderItems.length > 0 }"
				><!-- tabs -->
					<b-tab
						title="Kommentare"

					><!-- tab -->
						<div id="tab-history-table">
							<b-table
								id="table-log-manual"
								style="font-family:'Lucida Console', monospace"
								striped hover small
								:items="itemHistory.manual"
								:fields="fields.autoAndManual"
							></b-table>
							<!-- button
								v-if="'idle' === textInput.comment.state"
								class="btn btn-outline-secondary btn-block btn-sm"
								id="add_notiz_button"
								type="button"
								@click="commentAdd()"
							>
								Notiz <b>hinzufügen</b> ✚
							</button -->
							<b-overlay
								v-if="['edit','idle'].includes(textInput.comment.state)"
								id="overlay-background"
								:show="textInput.comment.savingInProgress"
								variant="transparent"
								opacity="0.80"
								blur="2px"
								rounded="sm"
							>
								<textarea
									v-model="textInput.comment.value"
									style="min-width: 100%;"
									rows="3"
									minlength="1"
								></textarea>
								<b-button
									v-if="textInput.comment.value"
									class="btn btn-primary float-right mb-2"
									type="button"
									size="sm"
									@click="commentSave()"
									:disabled="textInput.comment.savingInProgress || (!textInput.comment.value)"
								><b>hinzufügen</b></b-button>
								<b-button
									v-if="textInput.comment.value"
									class="btn btn-danger float-right mb-2 mr-1"
									type="button"
									size="sm"
									@click="commentAddAbort()"
									:disabled="textInput.comment.savingInProgress"
								><b>abbrechen</b></b-button>
							</b-overlay>
						</div>
					</b-tab>
					<b-tab :title-item-class="(customerOrder.shippingInfo) ? 'bg-danger rounded' :null" 
					title="Versand-Info" 
					><!-- to change the text color - needs additional when tab not activ than text color white - dont know how atm
						:title-link-class="(customerOrder.shippingInfo) ? 'text-light' : 'text-primary'"-->
					<!-- tab -->
						<span v-if="!textInput.shippingInfo.currentlyEditing" >{{customerOrder.shippingInfo}}</span>
						<b-button
							v-if="!textInput.shippingInfo.currentlyEditing"
							@click="() => textInput.shippingInfo.currentlyEditing = true"
							size="sm"
							variant="primary"
						><!-- button -->
							<span v-if="customerOrder.shippingInfo">✎</span>
							<span v-else>Versand-Info hinzufügen</span>
						</b-button>
						<textarea
							v-else
							v-model="textInput.shippingInfo.value"
							style="min-width: 100%;"
							rows="3"
							minlength="1"
						></textarea>
						<b-button
							v-if="textInput.shippingInfo.currentlyEditing && textInput.shippingInfo.value != customerOrder.shippingInfo"
							class="btn btn-primary float-right mb-2"
							type="button"
							size="sm"
							@click="saveShippingInfo()"
							:disabled="textInput.shippingInfo.savingInProgress || (textInput.shippingInfo.value == customerOrder.shippingInfo)"
						><!-- button -->
							<b v-if="customerOrder.shippingInfo">speichern</b>
							<b v-else>hinzufügen</b>
						</b-button>
						<b-button
							v-if="textInput.shippingInfo.currentlyEditing"
							class="btn btn-danger float-right mb-2 mr-1"
							type="button"
							size="sm"
							@click="() => { textInput.shippingInfo.value = customerOrder.shippingInfo; textInput.shippingInfo.currentlyEditing = false }"
							:disabled="textInput.shippingInfo.savingInProgress"
						>
							<b>Abbrechen</b>
						</b-button>
					</b-tab>
					<b-tab
						title="Verlauf"
						:disabled="textInput.comment.savingInProgress"
					><!-- tab -->
						<b-table
							id="table-log-auto"
							class="monospace"
							striped hover small
							:items="itemHistory.auto"
							:fields="fields.autoAndManual"
						></b-table>
					</b-tab>
					<b-tab
						v-if="multiorderItems.length > 0"
						title="Multiorder"
						:disabled="textInput.comment.savingInProgress"
					><!-- tab -->
						<b-overlay
							v-if="multiorderItems"
							id="overlay-background"
							:show="!multiorderItems"
							variant="transparent"
							opacity="0.80"
							blur="2px"
							rounded="sm"
						>
							<b-table
								id="table-multiorder-history"
								style="font-family:'Lucida Console', monospace"
								striped hover small
								:items="multiorderItems"
								:fields="fields.multiorder"
							><!-- table -->
								<template #cell(anything)="data">
									<div v-if="data.value.type === 'orderState'">
										<span v-if="data.value.value == 'Erstattet'"><span class="blinker">🔴</span>Erstattet</span>
										<span v-else >{{data.value.value}}</span>
									</div>
									<div v-else-if="data.value.type === 'date'">
										<span v-if="data.value.value.badgeLabel == 'Multiorder versendet'">
											<b-badge class="badge-orange">{{data.value.value.badgeLabel}}:{{data.value.value.date}}</b-badge>
										</span>
										<div v-else>
											<span>{{data.value.value.badgeLabel}}:</span>
											<b-badge class="badge-orange">{{data.value.value.date}}</b-badge>
										</div>
									</div>
								</template>
								<template #cell(search)="data">
									<a @click="openCustomerOrderSearch(data.value)" style="cursor:pointer; color:#3baced; text-decoration:underline;">Öffnen</a>
								</template>
								<template #cell(virtualQuantity)="data">
									{{ (data.value > 0) ? data.value : "-" }}
								</template>
							</b-table>
						</b-overlay>
					</b-tab>
				</b-tabs>
			</b-card>
		</div>
	</div>
</template>
<style>
	.blinker {
	animation: blinkerkeyframe 1s linear infinite;
	}
	@keyframes blinkerkeyframe {
	50% { opacity: 0; }
	}
	.contains-multiorder-history > div > ul > .nav-item:last-child > a[role="tab"] {
		background-color: rgb(252, 177, 3) !important;
		color: white;
	}
	.monospace {
		font-family:'Lucida Console', monospace
	}
    .col-date {
		max-width: 175px;
		width: 175px;
    }
	.col-user {
		max-width: 110px;
		width: 110px;
    }
	.badge-orange {
		background-color: #fcb103;
		color: black;
	}
</style>
<script>
import { useUserPreferenceStore } from '../../stores/UserPreferenceStore';

export default {
	setup(){
		const userPreferenceStore = useUserPreferenceStore();
		return {userPreferenceStore}
	},	
	props: ["customerOrder", "orderStates", "vendors", "marketAccounts" ],
	data() {
		return {
			// tabIndex: 0,
			customerOrderHistoryCount: -1, // used for determining if new CustomerOrderHistroy entries have been added.
			multiorderHistory: [],
			itemHistory: {
				auto: [],
				manual: [],
				multiorder: [],
			},
			fields: {
				multiorder: [
					{
						key: "customerOrderId",
						label: "weitere Bestellungen",
						sortable: false,
					},
					{
						key: "anything",
						label: "Status",
						sortable: false
					},
					{
						key: "virtualQuantity",
						label: "Menge (VMO)",
						sortable: false
					},
					{
						key: "search",
						label: "Suche",
						sortable: false
					}
				],
				autoAndManual: [
					{
						key: "lastUpdateTime",
						label: "Datum",
						sortable: true,
						thClass: 'col-date',
						//trClass: 'text-monospace',
						formatter: (s) => (s) ? moment(s).format('DD.MM.YYYY HH:mm') : '-'
					},
					{
						key: "lastUpdateUser",
						label: "Benutzer",
						thClass: 'col-user',
						sortable: true
					},
					{
						key: "comment",
						label: "Notiz",
						sortable: false,
						//variant: "danger",
					},
				],
			},
			textInput: {
				comment: {
					state: 'idle',
					value: null,
					savingInProgress: false
				},
				shippingInfo: {
					value: this.customerOrder.shippingInfo,
					savingInProgress: false,
					currentlyEditing: false
				}
			},
			isCOIHistoryOpen: false,

};
	},
	computed: {
		multiorderItems: function() {
			// notice: customerOrder.deliveryDate and customerOrder.customerorderitems[0].customerorderdeliveryaddition.deliveryDate
			// are not identical. They are whatever you want it to be.

			if(!this.multiorderHistory)  return null;
			return this.multiorderHistory.map( customerOrder => {
				let uff = {
					customerOrderId: customerOrder.id,
					search: customerOrder.id, // we need it for search, obv. Better design would've been making customerOrderId clickable.
					anything: {
						type: 'notset',
						value: null
					},
					virtualQuantity: 0
				};

				uff.anything.type = 'date';

				if(customerOrder.customermultiorders.length > 0)
				{
					if(customerOrder.customermultiorders[0].multiorder.deliveryDate) {
						uff.anything.value = {
							badgeLabel: 'Multiorder versendet',
							date: customerOrder.customermultiorders[0].multiorder.deliveryDate
						};

					}else{
						uff.anything.value = {
							badgeLabel: 'Multiorder in Warehouse',
							date: customerOrder.deliveryDate
						};


					}
					uff.anything.value.date = moment(uff.anything.value.date).format('DD.MM.YYYY HH:mm');
					uff.virtualQuantity = customerOrder.customermultiorders.map( cmo => cmo.virtualQuantity ).reduce ( (acc, cur) => acc + cur, 0 );

					if(uff.virtualQuantity > 0)
					{
						uff.anything.value.date = customerOrder.customermultiorders.map( cmo => (cmo.id % 10000) ).reduce(
							(accumulator, currentValue) => {
								return (accumulator == "") ? currentValue : (accumulator + ", " + currentValue)
							},
							""
						)
					}

				}else
				{

					if(['0000-00-00 00:00:00', '1999-11-30 00:00:00', '', null, undefined ].includes(customerOrder.deliveryDate))
					{
						uff.anything = {
							type: 'orderState',
							value: this.labelOrderState(customerOrder.orderState)
						}
						return uff;
					}

					uff.anything.value = {
						badgeLabel: 'Versanddatum',
						date: moment(customerOrder.deliveryDate).format('DD.MM.YYYY HH:mm')
					}
				};
				return uff;
			});
		}
	},
    watch: {
        customerOrder: {
            deep: true,
            handler: function(n) {
				if(n.customerorderhistories.length !== this.customerOrderHistoryCount) {
					this.customerOrderHistoryCount = n.customerorderhistories.length;
					this.populateTableItems()
				}
			}
		}
	},
	created() {
		 this.populateTableItems();
		 this.getMultiorderHistory();
	},
	methods: {
		labelOrderState(orderState)
		{
			switch(orderState)
			{
				       case this.orderStates.codes.OPEN:      return "⚪ Offen";
				break; case this.orderStates.codes.NEW:       return "⚪ Neu";
				break; case this.orderStates.codes.REFUND:    return 'Erstattet';
				break; case this.orderStates.codes.REFUND_OK: return "🔴 Erstattet";
				break; case this.orderStates.codes.DONE:      return "🟢 Erledigt";
				break; case this.orderStates.codes.WAIT:      return "🟢 Freigegeben";
				break; default: return "???";
			}
		},
		commentAdd() { this.textInput.comment.state = 'edit' },
		commentAddAbort() {
			this.textInput.comment.state = 'idle',
			this.textInput.comment.value = '';
		},
		commentSave() {
			this.textInput.comment.savingInProgress = true;
			let payload = {
				comment: this.textInput.comment.value,
				lastUpdateReason: "customerOrderIndex: add manual user comment",
				customerOrderId: this.customerOrder.id
			};
			Promise.all([
                axios.post('/customerorderhistory', payload),
                new Promise(r => setTimeout(r, 500))
            ]).then( ([response]) => { //yes, response must be wrapped in array brackets bc two promises (structural binding)
				this.customerOrder.customerorderhistories.push(response.data);
				this.populateTableItems();
				this.textInput.comment = {
					state: 'idle',
					value:  '',
					savingInProgress: false
				}
			}).catch( error => {
				alert("Kommentar konnte nicht abgespeichert werden!");
				console.error(error);
				this.textInput.comment.state = 'edit';
				this.textInput.comment.savingInProgress = false;
			});

		},
		populateTableItems() {

			this.itemHistory.auto   = this.customerOrder.customerorderhistories.filter( coh => "[auto]" === ((coh.comment) ? coh.comment.substr(0, 6) : ''));
			this.itemHistory.manual = this.customerOrder.customerorderhistories.filter( coh => "[auto]" !== ((coh.comment) ? coh.comment.substr(0, 6) : ''));
		},
		getMultiorderHistory() {
			axios.post('/customerorder/getmultiorderhistory',
				{id: this.customerOrder.id, marketAccountId: this.customerOrder.marketAccountId}
			).then( response => {
				this.multiorderHistory = response.data;
			});
		},
		openCustomerOrderSearch(customerOrderId) {
			var win = window.open(`/customerorder/${customerOrderId}`, "_blank");
			win.focus();
		},
		saveShippingInfo(shippingInfo) {
			this.textInput.shippingInfo.currentlyEditing = false;
			this.textInput.shippingInfo.savingInProgress = true;
			let payload = {
				customerOrderId: this.customerOrder.id,
				shippingInfo: this.textInput.shippingInfo.value
			};
			Promise.all([
				axios.post('/customerorder/save_shipping_info', payload),
				new Promise(r => setTimeout(r, 500))
			]).then( () => {
				// let newCustomerOrder = _.cloneDeep(this.customerOrder);
				// newCustomerOrder.shippingInfo = shippingInfo;
				this.customerOrder.shippingInfo  = this.textInput.shippingInfo.value;
				this.$emit('mutatedCustomerOrder', this.customerOrder);

				this.textInput.shippingInfo.currentlyEditing = false;
				// this.tabIndex++;
				setTimeout( () => {
					this.textInput.shippingInfo.savingInProgress = false;
					// this.tabIndex++;
				}, 150);

				this.$bvToast.toast( "Erfolgreich gespeichert.", {
					title: "Shipping-Info",
					autoHideDelay: 1000,
					appendToast: false,
					variant: 'success'
				});
			}).catch( error => {
				this.$bvToast.toast( "Speichervorgang ist fehlgeschlagen.", {
					title: "Shipping-Info",
					autoHideDelay: 9000,
					appendToast: false,
					variant: 'danger'
				});
				this.textInput.shippingInfo.currentlyEditing = false;
				console.error(error);
				this.textInput.shippingInfo.savingInProgress = false;
			});
		}
	}
};
</script>
